export enum SessionCreationIntent {
	RECORD = 'record',
	UPLOAD = 'upload',
	CONTINUE = 'continue',
	SAVE_FOR_LATER = 'save-for-later'
}
